import PropTypes from 'prop-types';

export default {
  hostname: PropTypes.string,
  domain: PropTypes.string,
  path: PropTypes.string,
  statusCode: PropTypes.number,
};
